import { InfoCircleOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag, Tooltip, Typography } from 'antd';

import { U_DESCRIPTION, U_KEY, U_NAME } from '@app/constants';
import type { NTags } from '@app/types';
import { generateKey, getContrastYIQ } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const adaptTagsDataToTable = (data: Array<NTags.Tag>) => {
  return data.map((tag: NTags.Tag) => {
    const { Id, Name, Description, IconId } = tag;

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <Tag
          data-testid="tag-name"
          key={generateKey('adaptTagsToTable', 'tag', Id)}
          icon={
            <FontAwesomeIcon
              icon={IconId as IconProp}
              style={{ marginRight: '5px', color: getContrastYIQ(tag.Color) }}
            />
          }
          color={tag.Color || 'white'}
        >
          <Text style={{ color: getContrastYIQ(tag.Color) }}>{Name}</Text>
        </Tag>
      ),
      [U_DESCRIPTION]: (
        <div key={generateKey('adaptTagsToTable', 'desc', Id)}>
          {Description && (
            <Tooltip title={Description}>
              <InfoCircleOutlined
                data-testid="tag-migration-hint"
                style={{
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#1677ff',
                  height: '16px',
                }}
              />
            </Tooltip>
          )}
        </div>
      ),
    };
  });
};
